import React from "react";

const Reject = (props) => {
    return (<div className="d-flex d-justify-center d-align-center text-white theme__font--bold view-height-100">
        You have rejected the invite.
    </div>)
} 

export default Reject